enum OWNERSHIP {
  JOINT_LIVES = 'Joint lives',
  // BE values
  SINGLE_LIVES = 'Single lives',
  WHOLE_FAMILY = 'Account owned',
  // FE values
  JOINT_CODE = 'joint',
  SINGLE_LIFE = 'Single life',
  ACCOUNT_OWNED = 'Account owned',
  TRUST = 'Trust',
}

export default OWNERSHIP;
